
import React from "react";
import { UseFormReturn } from "react-hook-form";
import { CameraFormValues } from "@/types/inventory";
import { CameraTabsForm } from "./CameraTabsForm";
import { useTranslation } from "@/hooks/useTranslation";

interface AddCameraFormProps {
  form: UseFormReturn<CameraFormValues>;
  onSubmit: (values: CameraFormValues) => Promise<void>;
  isEditing?: boolean;
}

export function AddCameraForm({ form, onSubmit, isEditing = false }: AddCameraFormProps) {
  const { t } = useTranslation();
  
  return (
    <CameraTabsForm 
      form={form} 
      onSubmit={onSubmit} 
      isEditing={isEditing} 
      submitLabel={isEditing ? t('update_camera') : t('add_camera')}
    />
  );
}
